// extracted by mini-css-extract-plugin
export default {"assign":"Assign_assign__Q+W5L","ticket":"Assign_ticket__tn0UO","ticketCard":"Assign_ticketCard__kOYxd","matchmakingCode":"Assign_matchmakingCode__Tgppb"};